import { Component, HostListener, AfterViewInit } from '@angular/core';
import { LARGE_SCREEN_SIZE, Size, SMALL_SCREEN_SIZE } from '../shared/common';
import { ResizeService } from '../shared/resize.service';

@Component({
  selector: 'app-size-detector',
  templateUrl: './size-detector.component.html',
  styleUrls: ['./size-detector.component.scss'],
  standalone: false,
})
export class SizeDetectorComponent implements AfterViewInit {
  screenWidth: number = 0;

  constructor(private responsiveService: ResizeService) {}

  ngAfterViewInit() {
    this.screenWidth = window.innerWidth;

    this.detectScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: Event) {
    this.screenWidth = window.outerWidth;
    this.detectScreenSize();
  }
  private detectScreenSize() {
    if (this.screenWidth <= SMALL_SCREEN_SIZE) {
      this.responsiveService.changeScreen(Size.MOBILE);
    } else if (SMALL_SCREEN_SIZE < this.screenWidth && this.screenWidth <= LARGE_SCREEN_SIZE) {
      this.responsiveService.changeScreen(Size.TABLET);
    } else {
      this.responsiveService.changeScreen(Size.MONITOR);
    }
  }
}
